module.exports = __webpack_public_path__ + "static/media/Artboard9.72e17de6.png";